import FacturaList from './FacturaList'
export {FacturaList}
export default FacturaList
